let RadioListItem = {
  props: ["id", "checked"],
  template: `<li class="list-group-item">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="col-1 px-0">
                            <div class="custom-control custom-radio">
                                <slot name="radio">
                                    <input type="radio" :id="id" class="custom-control-input">  
                                </slot>
                                <label class="custom-control-label type01" :for="id" @click.stop.prevent="$emit('checked')"></label> 

                            </div>
                        </div>
                        <div class="col-11 px-0">
                            <div class="" @click.prevent="$emit('checked')">  
                                <slot name="listItem"></slot>
                            </div>
                            <slot name="listItem_noneClick"></slot>
                        </div>
                        
                        </div>
                </li> 
            `,
  watch: {
    checked: function (value) {
      return value;
    },
  },
};

export default RadioListItem;
